import { render, staticRenderFns } from "./quickshopping.vue?vue&type=template&id=da155342&scoped=true&"
import script from "./quickshopping.vue?vue&type=script&lang=js&"
export * from "./quickshopping.vue?vue&type=script&lang=js&"
import style0 from "./quickshopping.vue?vue&type=style&index=0&id=da155342&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da155342",
  null
  
)

export default component.exports